/**
 * Canonical billing plan — same rules as api permissionService.normalizePlan.
 * Navbar i18n accepts any casing; access / PLAN_CONFIG keys must be Free|Pro|Enterprise.
 */

import { PLANS, type UserPlan } from '../config/permissions';

export function normalizeUserPlan(plan: string | null | undefined): UserPlan {
  const raw = String(plan || '').trim().toLowerCase();
  if (raw === 'enterprise') return PLANS.ENTERPRISE;
  if (raw === 'pro') return PLANS.PRO;
  return PLANS.FREE;
}

export function isPaidUserPlan(plan: string | null | undefined): boolean {
  const normalized = normalizeUserPlan(plan);
  return normalized === PLANS.PRO || normalized === PLANS.ENTERPRISE;
}

/**
 * Entitlements may be fresher than mock /api/me (upgrade Free → Pro).
 * Never let a Free snapshot clobber a billed Pro/Enterprise profile (downgrade heal).
 */
export function healBilledPlan(
  profilePlan: string | null | undefined,
  entitlementsPlan: string | null | undefined,
): UserPlan {
  const billed = normalizeUserPlan(profilePlan);
  if (entitlementsPlan == null || String(entitlementsPlan).trim() === '') return billed;
  const fromEntitlements = normalizeUserPlan(entitlementsPlan);
  if (fromEntitlements === PLANS.FREE && isPaidUserPlan(billed)) return billed;
  return fromEntitlements;
}
